module.exports = __webpack_public_path__ + "img/bingo_ball-87.53e18d8f.png";